import { WRONG_SHEET_MESSAGE } from './workbook.constants';
export const RETURN_APPROVAL_MESSAGES = {
    InvalidSelection: 'Selection is invalid. Please select at least one row and try again.',
    ContinuousSelection: 'The current selection is invalid for this operation. Please adjust your selection and try again.',
    ApprovalSequence: 'Please ensure that the previous statuses are signed off before proceeding',
    ApprovalFailed: 'Approval failed: An unexpected error occurred. Please try again later.',
  UndoFailed: 'Undo failed: An unexpected error occurred. Please try again later.',
  UndoTargetSignOffMissing: 'The selected sign-off is not complete for all selected returns.',
  UndoLaterSignOffExists: 'Cannot undo because a later approval sign-off exists for one or more selected returns.',
  UndoMixedStateSelection: 'Select returns with the same latest sign-off state to enable undo.',
  UndoProtectionFailed: 'Undo failed because sheet protection could not be restored. Please contact support.',
  UndoMissingPassword: 'Undo failed because the workpaper password is missing. Please refresh the add-in and try again.',
  InvalidReturnSelection: "Error: Don't select header & total rows or rows whose 'Return Name' is blank.",
  WrongSheet: WRONG_SHEET_MESSAGE,
  EFileConfirmationRequired: 'EFile Confirmation Number is required before confirming EFile Submission',
  };
  
  export const CLIENT_APPROVAL_CONSTANT = 'Client Approved';